var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"upload-btn icon icon-image"},[(!_vm.isMute)?_c('input',{attrs:{"title":"图片","type":"file","data-type":"image","accept":".png,.jpeg,.jpg"},on:{"change":_vm.sendUploadMessage}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }